import { Col, Row, Button, Card, Image } from "react-bootstrap";
import { useState, useEffect, useContext, useCallback } from "react";
import { ProfileContext } from "pages/Profile";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import headerImg from '../../../assets/logos/TMLogo.png';

export default function NextAssignment() {
  const { user: authUser } = useSelector(x => x.auth);
  const { profile } = useContext(ProfileContext);
  const url = process.env.REACT_APP_URL;
  const [meeting, setMeeting] = useState(null);
  const [showRoleDescription, setShowRoleDescription] = useState({});
  const [loadingAssignment, setLoadingAssignment] = useState(false);

  const toggleRoleDescription = (assignmentId) => {
    setShowRoleDescription(prev => ({
      ...prev,
      [assignmentId]: !prev[assignmentId]
    }));
  }

  const getRoles = useCallback(async () => {
    setLoadingAssignment(true);
    try {
      const response = await fetch(`${url}/roleNextAssignmentByUser/${profile?._id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setMeeting(data); // Assuming data contains the next meeting info
      // console.log('Next Assignment Data:', data);
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
    } finally {
      setLoadingAssignment(false);
    }
  }, [profile?._id, url]);

  useEffect(() => {
    // Wait for profile to be loaded before fetching next assignment
    if (profile && profile._id) {
      getRoles();
    }
  }, [getRoles, profile]);


  // PATCH role assignment confirmation
  const patchAssignment = async (assignmentId, value) => {
    setLoadingAssignment(true);
    try {
      await fetch(`${url}/roleAssignment/${assignmentId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}` // Assuming you have a token for auth
        },
        body: JSON.stringify({ confirmed: value }),
      });
      console.log(`Assignment ${assignmentId} updated to ${value}`);
      await getRoles();
    } catch (e) {
      console.error(e);
    }
    setLoadingAssignment(false);
  };

  return (
    <div style={{ border: '1px solid #495057', borderRadius: '10px', padding: '5px 10px 0 10px' }}>
      <Row className="justify-content-center">
        <Col xs={12} className="text-center">
          <h4 className="mt-1 ">Next Assignment</h4>
        </Col>
      </Row>
      <Row>
        <Col>
          {loadingAssignment && <div>Loading...</div>}
          {!loadingAssignment && meeting && (
            <Col xs={12} key={`col-${meeting._id}`}>
              <Card data-bs-theme={'dark'} className="mt-3 mb-3">
                <Card.Header>
                  <Row className="mt-0 mb-0">
                    <Row>
                      <Col xs={8} lg={9}><Link to={`/meeting/${meeting._id}`}><h5><span style={{ fontSize: "0.8rem" }}>#{meeting.meetingNumber}</span> {meeting.meetingTheme}</h5></Link></Col>
                      <Col xs={4} lg={3}>
                        <Row className="mt-0 mb-0">
                          <Col><p className="text-end mt-0 mb-0">{meeting.meetingDate}</p></Col>
                        </Row>
                        <Row className="mt-0 mb-0">
                          <Col><p className="text-end mt-0 mb-0">{meeting.meetingTime}</p></Col>
                        </Row>
                      </Col>
                    </Row>
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs={12} lg={6} className="mb-3">
                      <Row className="bigCard" key={`row-${meeting._id}`}>
                        <Col xs={12}>
                          <Row className="meetings-cardbig-bg">
                            <Col>
                            </Col>
                          </Row>
                          <Row className="justify-content-center">
                            <Col >
                              <h4 className="not-found-title" style={{ fontSize: '2rem', marginLeft: '10px', marginRight: '10px', marginTop: '-30%' }}>{meeting.meetingTheme}</h4>
                            </Col>
                            <Col className='meetings-cardbig-logo'><Image src={headerImg} alt="Toastmasters Logo" /></Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12} lg={6} className="mb-3">
                      {meeting.roleAssignments.map((assignment) => (
                        <div key={`assignment-${assignment._id}`} className="mb-3">
                          <Row className="mt-1 mb-1">
                            <Col
                              className="text-start"
                              onClick={() => toggleRoleDescription(assignment._id)}
                              style={{ cursor: 'pointer' }}
                            >
                              <h4>{assignment.role?.name || 'N/A'} <i className="bi bi-info-circle" style={{ color: '#00507a' }}></i></h4>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <div
                                dangerouslySetInnerHTML={{ __html: assignment.role?.description }}
                                style={{ display: showRoleDescription[assignment._id] ? 'block' : 'none' }}
                              ></div>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                            </Col>
                          </Row>
                          <Row className="mt-1 mb-1">
                            <Col className="text-start">
                              <span
                                style={{
                                  fontStyle: 'italic',
                                  fontWeight: 'bold',
                                  color:
                                    assignment.confirmed === true
                                      ? '#198754'
                                      : assignment.confirmed === false
                                        ? '#dc3545'
                                        : '#ffec83'
                                }}
                              >
                                Status: {assignment.confirmed === true
                                  ? "Confirmed"
                                  : assignment.confirmed === false
                                    ? "Rejected"
                                    : "Waiting for confirmation"}
                              </span>
                            </Col>
                            <Col className="text-end">
                              {(authUser.user._id === profile._id ||
                                (Array.isArray(authUser.user.clubRoles) &&
                                  (authUser.user.clubRoles.includes('President') ||
                                    authUser.user.clubRoles.includes('Vice President of Education'))))
                                ? (
                                  assignment.confirmed === undefined || assignment.confirmed === null
                                    ? (
                                      <>
                                        <Button
                                          variant="danger"
                                          disabled={loadingAssignment[assignment._id]}
                                          onClick={() => patchAssignment(assignment._id, false)}
                                        ><i className="bi bi-x-square" /> Reject</Button>{' '}
                                        <Button
                                          variant="success"
                                          disabled={loadingAssignment[assignment._id]}
                                          onClick={() => patchAssignment(assignment._id, true)}
                                        ><i className="bi bi-check-square" /> Accept</Button>
                                      </>
                                    )
                                    : (
                                      <Button
                                        variant="secondary"
                                        disabled={loadingAssignment[assignment._id]}
                                        onClick={() => patchAssignment(assignment._id, null)}
                                      ><i className="bi bi-arrow-counterclockwise" /> Reset</Button>
                                    )
                                )
                                : null}
                            </Col>
                          </Row>
                        </div>
                      )
                      )
                      }
                    </Col>
                  </Row>
                </Card.Body>


              </Card>
            </Col>
          )}
          {!loadingAssignment && !meeting && (
            <div>No upcoming assignments found.</div>
          )}
        </Col>
      </Row>
    </div>
  );
}